import { actionNames, actionPrefixes, objectTypes } from "@newsela/snitch";

import ExportablesBaseModal from "@/components/AIComponents/ExportablesModal/ExportablesBaseModal";
import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";
import { ASSESSMENT_TYPE } from "@/types/models";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import ViewableActivity from "@/view/TeacherActivityContainer/ViewableActivity";

const TeacherComponent = ({
  dispatch,
  setVisibleActivityIds,
  visibleActivityIds,
}: {
  dispatch: () => void;
  setVisibleActivityIds: () => void;
  visibleActivityIds: string[];
}) => {
  const { canSeeAiFeatures } = useGetUserProperties();

  const {
    assignedTemplates,
    content,
    handleTemplateSelection,
    isAssignableGraphicOrganizersActivityChecked,
    isContentSupported,
    isInAssignGraphicOrganizersExperiment,
    levelId,
    modalTriggerRef,
    setIsAssignableGraphicOrganizersActivityChecked,
  } = useExportablesContext();

  const hasSelectedGraphicOrganizerToAssign = assignedTemplates?.length > 0;

  const checkboxQaSelector = hasSelectedGraphicOrganizerToAssign
    ? "remove-graphic-organizer-activity-from-assignment"
    : "add-graphic-organizer-activity-to-assignment";

  const eventProperties = {
    objectType: objectTypes.graphicOrganizer,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.interact,
    ref: modalTriggerRef,
    streamProperties: {
      content_type: content.content_type,
      content_id: levelId,
      description: "Open modal for exportable resources",
    },
  };

  const handleClick = () => {
    handleTemplateSelection();
  };

  if (
    !isContentSupported ||
    !isInAssignGraphicOrganizersExperiment ||
    !canSeeAiFeatures
  )
    return null;

  const toggleGraphicOrganizers = (isSelected: boolean) => {
    setIsAssignableGraphicOrganizersActivityChecked(isSelected);

    if (!hasSelectedGraphicOrganizerToAssign) {
      handleTemplateSelection();
    }
  };

  return (
    <>
      <ViewableActivity
        assessmentType={ASSESSMENT_TYPE.GRAPHIC_ORGANIZERS}
        buttonDataProps={{
          "data-qa-selector": "open-exportables-modal-button",
        }}
        checkboxDataProps={{ "data-qa-selector": checkboxQaSelector }}
        dispatch={dispatch}
        isSelected={
          hasSelectedGraphicOrganizerToAssign &&
          isAssignableGraphicOrganizersActivityChecked
        }
        label="Graphic Organizers"
        onClick={handleClick}
        eventProperties={eventProperties}
        setVisibleActivityIds={setVisibleActivityIds}
        visibleActivityIds={visibleActivityIds}
        toggleGraphicOrganizers={toggleGraphicOrganizers}
      />

      <ExportablesBaseModal isStudent={false} />
    </>
  );
};

export default TeacherComponent;
